import FooterContacts from "./FooterContacts";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative mt-auto">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-screen border-t border-border-300 -z-10" />
      
      <div className="container px-0 pt-16 pb-10 flex gap-7">
        <FooterContacts />
      </div>
      
      <div className="w-full text-center text-xs  text-text-300 font-normal pb-5">
        {t("home.footer.copyrightLine1")}
        <br />
        {t("home.footer.copyrightLine2")}
      </div>
    </footer>
  );
}




